<template>
  <div id="picture" v-if="info.attchList[0] && info.attchList[0]">
    <img :src="url+info.attchList[0].filePath+info.attchList[0].ext" alt="">
  </div>
</template>

<script>
export default {
  data(){
    return{
      info:this.$utils.getInfo(),
      url:sessionStorage.getItem('baseUrl')
    }
  }
}
</script>

<style lang="less" scoped>
#picture{
  img{
    width: 100%;
    max-width: 660px;
    display: inline-block;
  }
}
</style>


